import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

@Component({
    selector: 'lib-create-password',
    templateUrl: './create-password.component.html',
    styleUrls: ['./create-password.component.scss', '../login/login.ux.scss', '../reset-password/reset-password.component.scss'],
})
export class CreatePasswordComponent extends ResetPasswordComponent { }
